import { ModelApiService } from './BaseApiService'

export default class DevicesApiService extends ModelApiService {
  constructor() {
    super('devices')
  }

  /**
   * Request to get a candidates registered devices
   * @param {number} candidateId
   */

  async getDevicesByCandidate(candidateId) {
    return await this.get(`candidate/${candidateId}`)
  }
}
